export * from './chips.module';
export * from './mini-chips/mini-chips.component';
